export default "__VITE_ASSET__DzwbZjXV__"